import { Component, h, Prop, Event, EventEmitter, State, Element } from "@stencil/core";

@Component({
  tag: "datagrid-filter-text-input",
  shadow: false,
})
export class DatagridFilterTextInput {
  @Element() el!: HTMLElement;
  /**
   * The ID of the grid to which this filter belongs.
   * This is used to identify which grid the filter is associated with.
   * It is passed to the filterChanged event when the filter value changes.
   * @example "grid-1"
   * @type {string}
   * @required
   * @description The ID of the grid to which this filter belongs.
   * This is used to identify which grid the filter is associated with.
   * It is passed to the filterChanged event when the filter value changes.
   * @default ""
   */
  @Prop() grid_id!: string;
  /**
   * The field name to which this filter is applied.
   * This is used to identify which field the filter is associated with.
   * It is passed to the filterChanged event when the filter value changes.
   * @example "eligible_year"
   * @type {string}
   * @required
   * @description The field name to which this filter is applied.
   * This is used to identify which field the filter is associated with.
   * It is passed to the filterChanged event when the filter value changes.
   * @default ""
   */
  @Prop() field!: string;
  /**
   * The label to be displayed for this filter.
   * This is used to identify the filter in the UI.
   * @example "Eligible Year"
   * @type {string}
   * @required
   * @description The label to be displayed for this filter.
   * This is used to identify the filter in the UI.
   * @default ""
   */
  @Prop() label!: string;
  /**
   * The placeholder text to be displayed in the input field.
   * This is used to provide a hint to the user about what to enter in the input field.
   * @example "Enter text"
   * @type {string}
   * @default "Enter text"
   */
  @Prop() placeholder = "Enter text";
  /**
   * The type of the filter.
   * This is used to identify the type of filter in the UI.
   * @example "text"
   * @type {string}
   * @default "text"
   */
  @Prop() initialValue = "";

  @Event() filterChanged: EventEmitter<{
    grid_id: string;
    field: string;
    value: string;
    type: string;
  }>;

  @State() value: string = this.initialValue;

  handleInputChange(event: any) {
    this.value = event.target.value;
    this.emitFilterChange();
  }

  emitFilterChange() {
    this.filterChanged.emit({
      grid_id: this.grid_id,
      field: this.field,
      value: this.value,
      type: "datagrid-filter-text-input",
    });
    // Vue 2: emit 'input' event
    this.el.dispatchEvent(new CustomEvent('input', {
      bubbles: true,
      composed: true,
      detail: this.value,
    }));

    // Vue 3: emit 'update:modelValue' event
    this.el.dispatchEvent(new CustomEvent('update:modelValue', {
      bubbles: true,
      composed: true,
      detail: this.value,
    }));
  }

  render() {
    return (
      <div class="datagrid-filter-text-input">
        <signet-input
          label={this.label}
          value={this.value}
          id={this.field}
          onInput={(e: any) => this.handleInputChange(e)}
        ></signet-input>
      </div>
    );
  }
}
